module.exports = __webpack_public_path__ + "img/1580370857.65b49bba.jpg";